import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CheckLogin } from "../services/user/user";
import { setUserCredentials } from "../redux/user/userSlice";
import { useNavigate, useLocation } from "react-router-dom";

export const useIsLogin = () => {
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleCheckLogin = async () => {
    try {
      const res = await CheckLogin();
      const userData = res.data.value;

      // Update Redux state
      dispatch(setUserCredentials(userData));
      setIsLogin(true);

      // If we're on an auth page and user is logged in, redirect to home
      if (pathname.includes('/auth')) {
        navigate('/', { replace: true });
      }
    } catch (error) {
      setIsLogin(false);

      // Only redirect to login if we're not already on an auth page or the download page
      if (!pathname.includes('/auth') && pathname !== '/download') {
        navigate("/auth/login", { replace: true });
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleCheckLogin();
  }, [pathname]); // Add pathname back to dependencies

  return [loading, isLogin];
};